import { defaultVolumeStrategyProvider, selectFirstReadyStrategy, } from './volumeRenderStrategy.js';
import { gpuSettingsForRender } from '../../utilities/gpuSettingsPresets.js';
export function resolveVolumeTexture(volume, options = {}) {
    const { provideStrategies = defaultVolumeStrategyProvider, selectStrategy = selectFirstReadyStrategy, viewportId, } = options;
    const isLegacy = options.provideStrategies === undefined &&
        options.selectStrategy === undefined;
    if (!volume?.voxelGrid) {
        return {};
    }
    const strategies = provideStrategies({
        volume,
        gpuSettings: gpuSettingsForRender(),
        viewportId,
        reason: 'initial',
    });
    const strategy = selectStrategy({
        strategies,
        volume,
        viewportId,
    });
    const base = strategy?.bindings().find((binding) => binding.role === 'base');
    if (isLegacy && strategy && base) {
        volume.pinTextureSet(strategy.name);
    }
    return { strategy, texture: base?.texture };
}
export default resolveVolumeTexture;
